import { render } from "./DesignLayoutChild.vue?vue&type=template&id=78e81824&scoped=true"
import script from "./DesignLayoutChild.vue?vue&type=script&lang=js"
export * from "./DesignLayoutChild.vue?vue&type=script&lang=js"

import "./DesignLayoutChild.vue?vue&type=style&index=0&id=78e81824&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e81824"]])

export default __exports__